import { CLEAN_MTOKNA_NEWSLETTER, FETCH_MTOKNA_NEWSLETTER } from './types';
import { __, request, toNumber } from '../functions';

/**
 * Nacitanie sablony.
 *
 * @param {Screen} screen
 * @param {number} id
 */
export const fetchMtoknaNewsletter = (screen, id) => {
    return dispatch => request(`/mtokna/viewNewsletter/${id}`).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_NEWSLETTER, payload: data });
    });
};

/**
 * Vytvorime sablonu.
 *
 * @param {Screen} screen
 * @param {Object} data
 */
export const createMtoknaNewsletter = (screen, data) => {
    const edit = toNumber(data.id) > 0;

    return dispatch => request(`/mtokna/${edit ? 'editNewsletter' : 'createNewsletter'}`, data, 'POST').then(response => {
        const { status } = response.data;

        screen.setState({ loading: false });

        if (status === 'error') {
            // Nepodarilo sa ulozit sablony
            screen.showSnackbar('error', __('Nepodarilo sa uložiť newsletter'));
            return;
        }

        window.location = '/newsletters';
    });
};

/**
 * Vycistenie sablony.
 */
export const cleanMtoknaNewsletter = () => ({ type: CLEAN_MTOKNA_NEWSLETTER });
